import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section id="hero" className="hero">
      <div className="hero-background"></div>
      <div className="hero-image-overlay" style={{ backgroundImage: 'url(/images/hero.jpg)' }}></div>
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">
            We Are <span className="gradient-text">6 C's</span>
          </h1>
          <p className="hero-subtitle">
            Your end-to-end creative powerhouse — built on Creation, Curation, Connection, 
            Conversion, Consistency, and Customer-Centricity.
          </p>
          <p className="hero-description">
            Everything your brand needs, all aligned under one strategic roof. Anytime. Anywhere.
          </p>
          <div className="hero-cta">
            <a href="#what-we-do" className="btn-primary">
              Explore Our Services
            </a>
            <a href="#contact" className="btn-secondary">
              Get In Touch
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

